/*
    © 2021 NetSuite Inc.
    User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
    provided, however, if you are an authorized user with a NetSuite account or log-in, you
    may use this code subject to the terms that govern your access and use.
*/

/**
* @NApiVersion 2.x
*BrandsPage.List.Model.js
*/
define([
    'N/search',
    'N/runtime',
    'N/record',
    'N/cache',
    'N/log',
    'N/file'
], function BrandsPageListModel(
    Search,
    Runtime,
    Record,
    Cache,
    Log,
    File
) {
    'use strict';


    var BrandsPageListModel = {
        get: function (request) {
            var type = 'customrecord_brands_list';
            var filters = [
                {name: 'isinactive', operator: Search.Operator.IS, values: 'F'},
                {name: 'custrecord_jhd_dnd_in_web_store', operator: Search.Operator.IS, values: 'F'}
            ]; 
            var columns = ['internalid','custrecord14','custrecord15','name',
        {name: 'custrecord16', sort: Search.Sort.ASC}]
            
            var searchResults = Search.create({     
                type: type,
                filters:filters,
                columns: columns
            }).run().getRange({start: 0, end: 1000});
            
            var mappedResults = searchResults.map(function (result) {

                var imageId = result.getValue('custrecord14') || null;
                var imageURL;
                var resizedImageURL = null;

                if (imageId) {
                    imageURL = File.load({
                        id: imageId
                    })
                }

                if (imageURL) {
                    var separator = imageURL.url.indexOf('?') === -1 ? '?' : '&';
                    resizedImageURL = imageURL.url + separator + 'resizeid=3&resizew=150&resizeh=150';
                }

                return {
                    internalid: result.getValue('internalid'),
                    brand: result.getValue('name'),
                    image: resizedImageURL,
                    link: result.getValue('custrecord15'),
                    sortorder: result.getValue('custrecord16')
                }
            });
            
            return mappedResults.length == 1 ? mappedResults[0] : mappedResults
        }
    }
    return BrandsPageListModel
});
